import React, { useState, useLayoutEffect, useEffect } from "react";

// libraries
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// components
import colors from "core/colors";
import OffsetGrid from "core/OffsetGrid";
import SectionContainer from "core/SectionContainer";
import Heading from "core/Heading";
import BodyText from "core/BodyText";
import NounProEduForm from "./Form";
import Flexbox from "core/Flexbox";
import breakpoints from "core/breakpoints";

// styles
import {
    EduOrderTitle,
    CheckoutPageHeading,
    SubscriptionTypeContainer,
    IconSubInfo,
    SubscriptionSubText
} from "subscriptions/styles";

// data
import {
    nounProEduPageTitle,
    YearlyIconSubscription,
    EDU_PER_YEAR_COST,
    perYear,
    initialForm
} from "subscriptions/data";

import { NOUN_PRO_EDU_LANDING_PAGE } from "data/links";

// helpers
import { useViewport } from "js/hooks/useViewport";
import { useAuth } from "frontend/hooks/useAuth";
import { useHistory } from "react-router-dom";

const NounProEduCheckout = () => {
    const { currentUser = {} } = useAuth();
    const history = useHistory();

    useLayoutEffect(() => {
        const { isEduApproved } = currentUser;
        if (!isEduApproved) {
            history.replace(NOUN_PRO_EDU_LANDING_PAGE);
        }
    }, []);

    const { browserWidth } = useViewport();
    const [form, setForm] = useState(initialForm);

    const stripePromise = loadStripe(window._nounConfig.stripePublishable);

    return (
        <SectionContainer
            bgColor={colors.secondary.orca}
            removeLeftRightPadding={browserWidth < breakpoints.beforeTablet.px}
        >
            <CheckoutPageHeading
                type="h1"
                size="xl"
                headingColor={colors.primary.diamond}
                alignment="center"
                topSpacing="none"
                bottomSpacing="4xl"
            >
                {nounProEduPageTitle}
            </CheckoutPageHeading>
            <OffsetGrid sm={12} md={12} lg={8}>
                <SectionContainer
                    bgColor={colors.primary.snow}
                    topSpacing="2xl"
                    bottomSpacing="2xl"
                >
                    <OffsetGrid sm={12} md={8} lg={6}>
                        <EduOrderTitle>Order Item</EduOrderTitle>

                        <SubscriptionTypeContainer>
                            <IconSubInfo>
                                <Flexbox flexDirection="column">
                                    <BodyText size="lg">
                                        {YearlyIconSubscription}
                                    </BodyText>
                                    <SubscriptionSubText>
                                        NounPro for Education
                                    </SubscriptionSubText>
                                </Flexbox>
                                <Flexbox
                                    flexDirection="column"
                                    alignItems="flex-end"
                                >
                                    <Heading size="xs">
                                        ${EDU_PER_YEAR_COST}
                                    </Heading>
                                    <BodyText
                                        size="sm"
                                        copyColor={colors.secondary.oolong}
                                    >
                                        {perYear}
                                    </BodyText>
                                </Flexbox>
                            </IconSubInfo>
                        </SubscriptionTypeContainer>

                        <Elements stripe={stripePromise}>
                            <NounProEduForm
                                itemPrice={EDU_PER_YEAR_COST}
                                showOrderSummary={false}
                                setForm={setForm}
                                form={form}
                            />
                        </Elements>
                    </OffsetGrid>
                </SectionContainer>
            </OffsetGrid>
        </SectionContainer>
    );
};

export default NounProEduCheckout;
